import {match} from 'ts-pattern';

import type {
  BulkOperationActionDefinition,
  BulkOperationActionDefinitions,
} from '../types/BulkOperationActionDefinition';

export function getBulkOperationActionDefinition(
  actionCode: string,
  definitions: BulkOperationActionDefinitions
): BulkOperationActionDefinition {
  const definition = definitions[actionCode];
  if (definition === undefined) {
    return {title: actionCode};
  }
  const variant = match(definition.variant)
    .with(undefined, () => undefined)
    .with('danger', 'dangerOutlined', 'dangerGhost', 'dangerLink', () => 'danger' as const)
    .otherwise(() => 'primary' as const);
  return {...definition, variant};
}
